/* eslint-disable import/prefer-default-export */

export const EVENT_STATUS = {
  UPCOMING: 'EVENT_STATUS_UPCOMING',
  LIVE: 'EVENT_STATUS_LIVE',
  ENDED: 'EVENT_STATUS_ENDED',
};
